import React from 'react';
import FenceLine from '../FenceLine';
import { FenceGroup, ItemType, iFenceDetails } from '../../../../../shared/interfaces';
import './FencesList.scss';

interface FencesListProps {
  fences: iFenceDetails[];
  itemType: ItemType;
  visibleRegions: string[];
  onToggleFence: (id: string, on: boolean) => void;
  isGlobalPage?: boolean;
}

const FencesList: React.FC<FencesListProps> = ({
  fences,
  itemType,
  visibleRegions,
  onToggleFence,
}) => {
  if (fences.length === 0) {
    return (
      <div className="FencesList-NoResults">
        No fences found
      </div>
    );
  }

  return (
    <div className="FencesList">
      {fences.map((fence) => (
        <FenceLine
          key={fence.id}
          fenceGroup={FenceGroup.FENCE}
          isVis={visibleRegions.includes(fence.id)}
          fence={fence}
          itemId={fence.itemId}
          itemType={itemType}
          toggler={onToggleFence}
          isGlobalPage
        />
      ))}
    </div>
  );
};

export default FencesList;